import { render, staticRenderFns } from "./SettingsPopup.vue?vue&type=template&id=3aebae40&scoped=true"
import script from "./SettingsPopup.vue?vue&type=script&lang=ts&setup=true"
export * from "./SettingsPopup.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./SettingsPopup.vue?vue&type=style&index=0&id=3aebae40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aebae40",
  null
  
)

export default component.exports